function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h14v14H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.094 4.779a.547.547 0 010 .773l-3.668 3.67a.547.547 0 01-.774 0L3.906 7.474a.547.547 0 11.773-.774l1.36 1.36L9.32 4.78a.547.547 0 01.773 0zM14 7c0 3.87-3.131 7-7 7-3.87 0-7-3.131-7-7 0-3.87 3.131-7 7-7 3.87 0 7 3.131 7 7zm-1.094 0A5.903 5.903 0 007 1.094 5.903 5.903 0 001.094 7 5.903 5.903 0 007 12.906 5.903 5.903 0 0012.906 7z",
  fill: "#2AB770"
}))));